var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bloco-categoria-monitoramento-agricola"}},[_c('div',{staticClass:"container-categoria view-container"},[_c('h3',[_vm._v(_vm._s(_vm.texto))]),_c('div',{staticClass:"categoria-lista"},[_c('BaseButton',{attrs:{"round":""}},[_vm._v("Round")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }